import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://mingcidianzi162.cn${item.href}` : undefined,
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}

export function getBreadcrumbForCategory(slug: string): BreadcrumbItem[] {
  const cat = categories.find((c) => c.slug === slug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '文章分类', href: `/category/${slug}` },
  ];
}

export function getBreadcrumbForArticle(articleSlug: string, categorySlug: string, articleTitle: string): BreadcrumbItem[] {
  const cat = categories.find((c) => c.slug === categorySlug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '文章分类', href: `/category/${categorySlug}` },
    { label: articleTitle },
  ];
}